(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .service("rolloverStatusCheck", rolloverStatusCheckService);

  /** @ngInject */
  function rolloverStatusCheckService() {
    // Rollover status codes (see Karcher documentation)
    var normalStatusLIst = [
      "2.0",
      "3.0",
      "4.0",
      "5.0",
      "6.0",
      "7.0",
      "9.0",
      "10.0",
      "12.0"
    ];
    var alarmStatusLIst = [
      "0.0",
      "1.0",
      "8.0",
      "11.0",
      "13.0",
      "14.0",
      "15.0",
      "16.0",
      "17.0",
      "18.0",
      "19.0",
      "20.0",
      "21.0",
      "22.0",
      "23.0",
      "24.0",
      "25.0",
      "98.0"
    ];

    this.normalStatus = function (status) {
      return normalStatusLIst.includes(status);
    };

    this.alertStatus = function (status) {
      return alarmStatusLIst.includes(status);
    };

    this.undefinedStatus = function (status) {
      return status === "99.0";
    };
  }
})();
